var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "transfer-detail-dialog" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialogNew",
          attrs: {
            visible: _vm.configVo.dialog,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.cancel,
            title: _vm.operationName,
            width: "700px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.configVo, "dialog", $event)
            }
          }
        },
        [
          _c("ul", { staticClass: "confirm-info" }, [
            _c("li", [
              _c("i", {
                staticClass: "icon-essential-information icons essential"
              }),
              _vm._v(" "),
              _c("span", { staticClass: "info-title" }, [
                _vm._v("1. 学生基本信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-box box" }, [
                _vm._v("\n          姓名：\n          "),
                _c("span", { staticClass: "info-name" }, [
                  _vm._v(_vm._s(_vm.form.studentName))
                ]),
                _vm._v("\n          性别：\n          "),
                _c("span", [_vm._v(_vm._s(_vm.form.studentSex))]),
                _vm._v("\n          学籍号：\n          "),
                _c("span", [_vm._v(_vm._s(_vm.form.studentSid))])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("i", {
                staticClass: "icon-roll-out-information icons roll-out"
              }),
              _vm._v(" "),
              _c("span", { staticClass: "info-title" }, [
                _vm._v("2. 转出信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "show-box box" }, [
                _c("div", { staticClass: "name-box" }, [
                  _c("span", { staticClass: "name-titel" }, [
                    _vm._v("转出学校：")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm.form.oriProvinceName
                      ? _c("span", { staticClass: "show-name" }, [
                          _vm._v(_vm._s(_vm.form.oriProvinceName))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.oriCityName
                      ? _c("span", { staticClass: "show-name" }, [
                          _vm._v(_vm._s(_vm.form.oriCityName))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.oriCountyName
                      ? _c("span", { staticClass: "show-name" }, [
                          _vm._v(_vm._s(_vm.form.oriCountyName))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.oriSchoolName
                      ? _c("span", { staticClass: "show-name" }, [
                          _vm._v(_vm._s(_vm.form.oriSchoolName))
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("\n            转出学校当前学期：\n            "),
                  _c("span", [_vm._v(_vm._s(_vm.form.oriSchoolTermName))])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("\n            年级班级：\n            "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.form.oriGradeName) +
                        " " +
                        _vm._s(_vm.form.oriSchoolClassName)
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("i", {
                staticClass: "icon-transfer-information icons transfer"
              }),
              _vm._v(" "),
              _c("span", { staticClass: "info-title" }, [
                _vm._v("3. 转入信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "show-box box last-box" }, [
                _c("div", { staticClass: "name-box" }, [
                  _c("span", { staticClass: "name-titel" }, [
                    _vm._v("转入学校：")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm.form.destProvinceName
                      ? _c("span", { staticClass: "show-name" }, [
                          _vm._v(_vm._s(_vm.form.destProvinceName))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.destCityName
                      ? _c("span", { staticClass: "show-name" }, [
                          _vm._v(_vm._s(_vm.form.destCityName))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.destCountyName
                      ? _c("span", { staticClass: "show-name" }, [
                          _vm._v(_vm._s(_vm.form.destCountyName))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.destSchoolName
                      ? _c("span", { staticClass: "show-name" }, [
                          _vm._v(_vm._s(_vm.form.destSchoolName))
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("\n            转入学校当前学期：\n            "),
                  _c("span", [_vm._v(_vm._s(_vm.form.destSchoolTermName))])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("\n            年级班级：\n            "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.form.destGradeName) +
                        " " +
                        _vm._s(_vm.form.destSchoolClassName)
                    )
                  ])
                ])
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }